import ApiSerService from "@/common/api.service";
import { GET_DB_INFO, MODIFY_DB_CAPACITY } from "./actions.type";
import {
  SET_MODIFIED_DB_CAPACITY,
  SET_IS_LOADING,
  SET_ERROR,
  SET_DB_INFO
} from "./mutations.type";

export const getDefaultState = () => {
  return {
    currentCapacity: null,
    isLoading: false,
    error: null
  };
};
const state = getDefaultState();

const getters = {};

const actions = {
  [GET_DB_INFO](context, payload) {
    context.commit(SET_IS_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiSerService.get("api/v1/settings/describe-database")
        .then(({ data }) => {
          context.commit(SET_DB_INFO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
  [MODIFY_DB_CAPACITY](context, capacity) {
    context.commit(SET_IS_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiSerService.post("api/v1/settings/modify-db-capacity", capacity)
        .then(({ data }) => {
          context.commit(SET_MODIFIED_DB_CAPACITY, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_DB_INFO](state, response) {
    state.isLoading = false;
    state.currentCapacity = response.capacity;
  },
  [SET_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
    state.error = null;
  },
  [SET_MODIFIED_DB_CAPACITY](state, response) {
    state.error = null;
    state.isLoading = false;
  },
  [SET_ERROR](state, error) {
    state.isLoading = false;
    state.error = error;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
